import { render } from "./KeyGuidance.vue?vue&type=template&id=22c683fb&scoped=true&ts=true"
import script from "./KeyGuidance.vue?vue&type=script&lang=ts"
export * from "./KeyGuidance.vue?vue&type=script&lang=ts"

import "./KeyGuidance.vue?vue&type=style&index=0&id=22c683fb&lang=less&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/mobile-mpe-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c683fb"]])

export default __exports__